import React, { useRef, useState, useEffect } from 'react'
import './AboutSection.css'

const PASSIONS = [
  { icon: '💻', label: 'Informatique & IA' },
  { icon: '🎮', label: 'Jeux vidéo' },
  { icon: '🚗', label: 'Automobile' },
  { icon: '⚽', label: 'Football' },
  { icon: '🏎️', label: 'Karting' },
  { icon: '🏃', label: 'Course à pied' },
]

const LANGS = [
  { lang: 'Français', level: 'Maternelle', pct: 100 },
  { lang: 'Anglais', level: 'B2', pct: 70 },
  { lang: 'Espagnol', level: 'B1', pct: 45 },
]

const QUALITIES = ['Esprit d\'équipe', 'Aisance relationnelle', 'Autonome', 'Curieux', 'Polyvalent']

function useReveal(threshold = 0.15) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect() }
    }, { threshold })
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [threshold])
  return [ref, visible]
}

export default function AboutSection() {
  const [sectionRef, visible] = useReveal()

  return (
    <section id="about" className="section about-section" ref={sectionRef} aria-label="À propos">
      <div className={`section-inner about-inner ${visible ? 'visible' : ''}`}>

        {/* Left col */}
        <div className="about-left">
          <div className="section-label"><span>01</span> À propos</div>
          <h2 className="section-title">
            Qui suis-<span className="gradient-text">je ?</span>
          </h2>

          <p className="about-text">
            Je suis <strong>Quentin Ott</strong>, développeur web full-stack, passionné de data et d'intelligence artificielle.
            Né à Plaisir (78), j'ai débuté avec un <strong>Bac STMG spécialité SIG</strong> avant de me spécialiser en informatique via un <strong>BTS Systèmes Informatique aux Organisations </strong>.
          </p>
          <p className="about-text">
            Aujourd'hui en <strong>Bachelor 3 IA & Data à Ynov Campus Nanterre</strong>, je combine développement web, analyse de données et machine learning pour créer des solutions complètes.
            Je recherche une alternance pour mon <strong>Master Expert en science des données spécialisé en infrastructure data et en apprentissage automatique</strong> à Ynov Paris Campus(2026–2028).
          </p>
          <p className="about-text">
            En parallèle de mes études, je développe des sites web en <strong>freelance</strong> pour des restaurants, auto-écoles, taxis et associations depuis 2024.
          </p>

          {/* Languages */}
          <div className="about-langs">
            <h4 className="about-sub-title">Langues</h4>
            {LANGS.map(l => (
              <div key={l.lang} className="lang-row">
                <div className="lang-header">
                  <span className="lang-name">{l.lang}</span>
                  <span className="lang-level">{l.level}</span>
                </div>
                <div className="lang-bar">
                  <div
                    className="lang-fill"
                    style={{ '--pct': `${l.pct}%`, transitionDelay: visible ? '0.4s' : '0s' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right col */}
        <div className="about-right">
          {/* Passions */}
          <div className="about-card glass-card">
            <h4 className="about-card-title">
              <span className="gradient-text">Passions</span>
            </h4>
            <div className="passions-grid">
              {PASSIONS.map(p => (
                <div key={p.label} className="passion-item">
                  <span className="passion-icon">{p.icon}</span>
                  <span className="passion-label">{p.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Qualities */}
          <div className="about-card glass-card">
            <h4 className="about-card-title">
              <span className="gradient-text">Qualités</span>
            </h4>
            <div className="qualities-list">
              {QUALITIES.map(q => (
                <div key={q} className="quality-item">
                  <span className="quality-check">✓</span>
                  {q}
                </div>
              ))}
            </div>
          </div>

          {/* Info card */}
          <div className="about-card about-info-card glass-card">
            <div className="info-row">
              <span className="info-icon">📍</span>
              <span>Plaisir, 78370</span>
            </div>
            <div className="info-row">
              <span className="info-icon">📞</span>
              <a href="tel:0601862082">06 01 86 20 82</a>
            </div>
            <div className="info-row">
              <span className="info-icon">✉️</span>
              <a href="mailto:quentin.ott2511@gmail.com">quentin.ott2511@gmail.com</a>
            </div>
            <div className="info-row">
              <span className="info-icon">🚗</span>
              <span>Permis B</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
